import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ReplaySubject, Observable, BehaviorSubject } from 'rxjs';
import { filter, shareReplay, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';
import { LoaderService } from '../services/loader.service';
import { API } from './api.config';
import { DataFormatService } from './data-format.service';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  
  private publicContentSubject = new ReplaySubject<any>(1); // Almacena el último valor y lo comparte
  private privateContentSubject = new ReplaySubject<any>(1);
  private publicContentLoaded = false; // Indica si ya se cargó
  private privateContentLoaded = false;

  private baseUrl = environment.api;
  private publicHeaders = new HttpHeaders({
    'client': environment.client,
    'apikey': environment.apikey,
    'channelId': '20',
    'accept-language': 'es',
    'accountCd': environment.keycloakRealm,
  });

  constructor(private http: HttpClient,private configService: ConfigService, private loadingService: LoaderService, private dataFormatService: DataFormatService) { }

  // Método para obtener los datos desde el servicio. Funciona como una caché.
  // Comprueba si ya hay datos.Si no hay datos, realiza una llamada al servicio 
  getPublicContent(): Observable<any> {
    if (!this.publicContentLoaded) {
      this.publicContentLoaded = true; // Evita múltiples llamadas
      return this.refreshPublicContent();
    }
    return this.publicContentSubject.asObservable();
  }
  
  // Método para forzar la recarga de los datos desde el API
  refreshPublicContent(): Observable<any> {
    const channelId = '3';
    const version = '1';
    const identityType = 'DONOR';
    const apiUrl = `${this.baseUrl}${API.dipmal}${API.communications}${API.contents}${API.public}?channelId=${channelId}&version=${version}&identityType=${identityType}`;
    return this.http.get(apiUrl, { headers: this.publicHeaders }).pipe(
      tap(data => this.publicContentSubject.next(data)), // Actualiza el caché
      switchMap(() => this.publicContentSubject.asObservable().pipe(filter(data => data !== null))), // Espera hasta que haya datos
      shareReplay(1) // Evita que múltiples suscripciones disparen múltiples peticiones
      );;
  }

  getPrivateContent(): Observable<any> {
    if (!this.privateContentLoaded) {
      this.privateContentLoaded = true;
      return this.refreshPrivateContent();
    }
    return this.privateContentSubject.asObservable();
  }
  
  // Método para forzar la recarga de los datos desde el API
  refreshPrivateContent(): Observable<any> {
    const token = sessionStorage.getItem('tokenLogIn');
  
    if (!token) {
      console.error("No se encontró el token de autenticación. Esperando...");
      return new Observable(); // Devuelve un observable vacío para evitar errores
    }
  
    const channelId = '3';
    const show = 'active';
    const version = '1';
    const identityType = 'DONOR';
    const customerId = this.dataFormatService.extractFieldFromToken(token, 'customerId');
    const apiUrl = `${this.baseUrl}${API.dipmal}${API.communications}${API.contents}${API.customer}/${customerId}?channelId=${channelId}&show=${show}&version=${version}&identityType=${identityType}`;
  
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'accountCd': environment.keycloakRealm,
      'channelId': '20',
      'accept-language': 'es'
    });
  
    return this.http.get(apiUrl, { headers }).pipe(
      tap(data => this.privateContentSubject.next(data)), // Guarda en caché
      switchMap(() => this.privateContentSubject.asObservable().pipe(filter(data => data !== null))), // Espera los datos
      shareReplay(1)
    );
  }

}